import { Suspense, lazy } from 'react';
import CommonSkeleton from 'components/common/skeleton/CommonSkeleton';

const Index = lazy(() => import('components/l3System/downloadWeblink/Index'));

const DownloadWeblinkPage = () => {
	return (
		<div className='page-content user-module'>
			<Suspense fallback={<CommonSkeleton />}>
				<Index />
			</Suspense>
		</div>
	);
};
export default DownloadWeblinkPage;
